import React, { useState } from 'react';
import ReactDOM from 'react-dom';
import { useTranslation } from 'react-i18next';
import { ArrowPathIcon, XMarkIcon } from '@heroicons/react/24/outline';

// Small, non-intrusive banner that appears when a newer build has been deployed
// while this tab kept running the old bundle. Portaled to document.body so it
// escapes any page stacking context (project convention for floating UI).
// Dismissible locally; the refresh button hard-reloads to load the new bundle.
export default function UpdateAvailableBanner({ updateAvailable }) {
  const { t } = useTranslation('common');
  const [dismissed, setDismissed] = useState(false);

  if (!updateAvailable || dismissed) return null;

  return ReactDOM.createPortal(
    <div
      role="status"
      aria-live="polite"
      className="fixed inset-x-0 z-[10000] flex justify-center px-3 pointer-events-none"
      style={{ top: 'calc(env(safe-area-inset-top, 0px) + 0.75rem)' }}
    >
      <div className="pointer-events-auto flex items-center gap-3 max-w-md w-full sm:w-auto rounded-xl bg-gray-900 text-white shadow-2xl ring-1 ring-white/10 px-4 py-3">
        <ArrowPathIcon className="h-5 w-5 flex-shrink-0 text-indigo-300" aria-hidden="true" />
        <div className="min-w-0 flex-1">
          <p className="text-sm font-semibold leading-tight">
            {t('update.available', { defaultValue: 'Nova verzija dostupna' })}
          </p>
          <p className="text-xs text-white/70 leading-tight">
            {t('update.subtitle', {
              defaultValue: 'Osvježite za najnovije promjene.',
            })}
          </p>
        </div>
        <button
          type="button"
          onClick={() => window.location.reload()}
          className="flex-shrink-0 rounded-lg bg-indigo-600 hover:bg-indigo-500 transition-colors px-3 py-1.5 text-sm font-semibold text-white"
        >
          {t('update.refresh', { defaultValue: 'Osvježi' })}
        </button>
        <button
          type="button"
          onClick={() => setDismissed(true)}
          aria-label={t('actions.close', { defaultValue: 'Zatvori' })}
          className="flex-shrink-0 rounded-lg p-1 text-white/60 hover:text-white hover:bg-white/10 transition-colors"
        >
          <XMarkIcon className="h-5 w-5" aria-hidden="true" />
        </button>
      </div>
    </div>,
    document.body
  );
}
